// Feelings Station media. Every clip here keeps its own original soundtrack; Candy (Lumi's voice) is used
// only for the separate spoken introduction. Never invent links: an episode without `youtubeId` is not a full episode.
export const INTRO_TEXT = "Welcome to Feelings Station! Explore feelings, understand words, and practice asking for help.";

export const WELCOME_VIDEO = {
  src: "/videos/feelings-station/welcome.mp4",
  poster: "/videos/feelings-station/welcome-poster.jpg",
  captions: "/videos/feelings-station/welcome.en.vtt",
  title: "Welcome to Feelings Station",
};

export const TRAIN_VIDEO = {
  src: "/videos/feelings-station/all-aboard.mp4",
  poster: "/videos/feelings-station/all-aboard-poster.jpg",
  captions: "/videos/feelings-station/all-aboard.en.vtt",
  title: "All Aboard the Lumi Learning Express!",
  transcript: "All aboard the Lumi Learning Express!",
};

export const EPISODES = [
  {
    id: "what-did-mom-mean",
    title: "What Did Mom Mean?",
    description: "Listen to the whole sentence and practice asking for clarification.",
    status: "coming-soon",
    statusLabel: "Full episode coming soon",
    youtubeId: null,
    thumbnail: "/images/feelings/kids-adventure.webp",
    sneakPeek: {
      src: "/videos/feelings-station/what-did-mom-mean-sneak-peek.mp4",
      poster: "/images/feelings/kids-adventure.webp",
      captions: null, // pending: timed captions will be added from the supplied lyrics
      title: "Watch the Musical Sneak Peek",
    },
  },
];
